define((require) => {
    "use strict";

    const {defer}            = require("underscore");
    const $                  = require("jquery");
    const AbstractWidgetView = require("shared/ui/experience/widgets/AbstractWidgetView");

    /**
     * The view rendering an html widget.
     *
     * @class HTMLWidgetView
     * @constructor
     *
     * @cfg {HTMLWidgetModel} model The model of the html widget being rendered.
     */
    return AbstractWidgetView.extend("HTMLWidgetView", {

        tagName: "div",

        className: `${AbstractWidgetView.prototype.className} html-widget`,

        initialize(widget) {
            this.model = widget.model;
            this.viewModel = widget.viewModel;

            this.listenTo(this.model, "dropped:to:scene", this._onWidgetDrop);
            this.listenTo(this, "deselect", this._deselectHandler);
        },

        events: {
            mousedown: "_mouseDownHandler"
        },

        _mouseDownHandler() {
            defer(() => {
                this.model.set("isSelected", true);
            });
        },

        _isOnlySelection() {
            const {selection} = this.viewModel;
            return selection.isSingle() && selection.get("widgets")[0] === this;
        },

        _deselectHandler() {
            if (this._isOnlySelection()) {
                return;
            }

            if (this.model.get("isSelected")) {
                this.model.set("isSelected", false);
            }
        },

        _onWidgetDrop() {
            defer(() => {
                this.model.set("isSelected", true);
            });
        },

        updateRendering(element, bounds, active, edited) {
            const staticRepresentation = !this.options.enableAnimations;

            this._activeState = active;

            // When inside the viewer/player
            if (!edited || !staticRepresentation) {
                const htmlText = this.model.get("htmlText");

                element.empty();

                const iframe = $("<iframe />", {
                    src: "about:blank",
                    allowFullscreen: true
                });

                iframe.appendTo(element);

                const {contentWindow} = iframe[0];
                const iframeDoc = contentWindow ? contentWindow.document : null;

                if (iframeDoc) {
                    iframeDoc.open();
                    iframeDoc.write(htmlText);
                    iframeDoc.close();
                }

                iframe.css({
                    width:     "1px",
                    minWidth:  "100%",
                    height:    "1px",
                    minHeight: "100%"
                });
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/htmlWidget/HTMLWidgetView.js